import { render, staticRenderFns } from "./ModuleTile.vue?vue&type=template&id=023bf644&"
import script from "./ModuleTile.vue?vue&type=script&lang=js&"
export * from "./ModuleTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports